/**
 * Funkce pro skrytí libovolného info boxu na stránce detailu zápasu
 *
 * @param dataAttr Název data-atributu, podle kterého se box vyhledá (např. "data-info-box-error")
 */
export const hideInfoBox = (dataAttr: string): void => {
  const infoBox = document.querySelector<HTMLElement>(`[${dataAttr}]`);

  if (infoBox) {
    infoBox.remove();
  }
};
